module.exports = __webpack_public_path__ + "img/spain-flag.e511dcee.svg";